<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">

                    <header>
                        <figure><i class="icon icon-icon_company"></i></figure>
                        <div>
                            <span class="breadcrumb">
                                Checkin <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>

                    <main>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                                <form-scopes label='Scopes' v-model="resource"></form-scopes>

                                <form-datex label="Send mail" v-model="resource.send_at" :hide-time="false" time="00:00:00"></form-datex>

                                <form-select label="Locales" multiple="false" v-model="resource.locale" :id="locale" :options="$store.state.locales"></form-select>

                                <form-text label="Ref identifier" v-model="resource.ref_identifier"></form-text>
                                <form-text label="Guest id" v-model="resource.guest_id"></form-text>
                                <form-text label="firstname" v-model="resource.firstname"></form-text>
                                <form-text label="lastname" v-model="resource.lastname"></form-text>
                                <form-text label="gender" v-model="resource.gender"></form-text>
                                <form-text label="email" v-model="resource.email"></form-text>

                                <form-datex label="Start date" v-model="resource.start_at" :hide-time="false" time="00:00:00"></form-datex>
                                <form-datex label="End date" v-model="resource.end_at" :hide-time="false" time="23:59:59"></form-datex>

                                <form-text label="adult_count" v-model="resource.adult_count"></form-text>
                                <form-text label="child_count" v-model="resource.child_count"></form-text>
                                <form-text label="city_tax" v-model="resource.city_tax"></form-text>

                                <form-text label="total_rate" v-model="resource.total_rate"></form-text>

                                <!--<form-toggle label="Expire date" v-model="resource.add_expired_at"></form-toggle>-->

                                <form-datex label="Expire date" v-model="resource.exipred_at" :hide-time="false" time="23:59:59"></form-datex>

                                <form-select label="Devise par défaut" multiple="false" v-model="resource.currency" :default="resource.currency_id" :options="$store.state.currencies"></form-select>

                            </tab>
                        </tabs>

                    </main>
                </article>

            </div>
        </div>
    </transition>
</template>
<script>

    import ReservationService from './ReservationService.js';
    import Edit from '../../../layouts/Edit.vue';

    export default {
        extends: Edit,
        data () {
            return {
            }
        },
        mounted: function(){
            this.initialize()
        },
        methods:{
            getResource: function(){
                return ReservationService
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/checkin/reservation/Edit.vue